
import {  Spinner } from "react-bootstrap";

const LoadWraper = ({ children, isload }) => {
  if (isload) {
    return <div style={{ height: "41vh" }}>
      <Spinner animation="border" role="status" />
    </div>
  }

  return <>{children}</>;
}
export default LoadWraper